import Layout from '../../views/layout/index.vue';
import { lazy } from 'react';
import reactContainerFactory from '@/components/react-container/reactContainerFactory';

const rtsOutbound = {
  path: '/rtsoutbound',
  name: 'rtsOutbound',
  meta: {
    title: 'RTS Outbound',
    icon: 'RTS Outbound',
  },
  redirect: '/rtsoutbound/order',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'order',
      name: 'rtsOutbound.order',
      meta: {
        title: 'Order',
        filterSave: true,
      },
      component: () => import('../../views/rts-outbound/order/index.vue'),
    },
    {
      path: 'order/create',
      name: 'rtsOutbound.order.create',
      meta: {
        title: 'Create',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.order',
            title: 'Order',
          },
        ],
      },
      component: () => import('../../views/rts-outbound/order/create.vue'),
    },
    {
      path: 'order/edit/:orderNo',
      name: 'rtsOutbound.order.edit',
      meta: {
        title: 'Edit',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.order',
            title: 'Order',
          },
        ],
      },
      component: () => import('../../views/rts-outbound/order/create.vue'),
    },
    {
      path: 'order/detail/:id',
      name: 'rtsOutbound.order.detail',
      meta: {
        title: 'Order Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.order',
            title: 'Order',
          },
        ],
      },
      component: () => import('../../views/rts-outbound/order/detail.vue'),
    },
    {
      path: 'order/allocate/:orderNo',
      name: 'rtsOutbound.order.allocate',
      meta: {
        title: 'Allocate',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.order',
            title: 'Order',
          },
        ],
      },
      component: () =>
        import('../../views/rts-outbound/order/allocate-approve.vue'),
    },
    {
      path: 'order/approve/:orderNo',
      name: 'rtsOutbound.order.approve',
      meta: {
        title: 'Approve',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.order',
            title: 'Order',
          },
        ],
      },
      component: () =>
        import('../../views/rts-outbound/order/allocate-approve.vue'),
    },
    {
      path: 'task',
      name: 'rtsOutbound.task',
      meta: {
        title: 'Task',
      },
      redirect: '/rtsoutbound/task/picking',
      component: () => import('@/views/rts-outbound/task/index.vue'),
      children: [
        {
          path: 'picking',
          name: 'PC.RTSOutbound.Task.PickingTask.View',
          meta: {
            title: 'Picking Task',
            menuHide: true,
          },
          component: () => import('@/views/rts-outbound/task/index.vue'),
        },
        {
          path: 'new-picking',
          name: 'PC.RTSOutbound.Task.NewPicking',
          meta: {
            title: 'New Picking Task',
            menuHide: true,
          },
          component: () => import('@/views/rts-outbound/task/index.vue'),
        },
        {
          path: 'checking',
          name: 'PC.RTSOutbound.Task.Checking',
          meta: {
            title: 'Checking Task',
            menuHide: true,
          },
          component: () => import('@/views/rts-outbound/task/index.vue'),
        },
        {
          path: 'merging',
          name: 'PC.RTSOutbound.Task.Merging',
          meta: {
            title: 'Merging Task',
            menuHide: true,
          },
          component: () => import('@/views/rts-outbound/task/index.vue'),
        },
        {
          path: 'shipping',
          name: 'PC.RTSOutbound.Task.Shipping',
          meta: {
            title: 'Shipping Task',
            menuHide: true,
          },
          component: () => import('@/views/rts-outbound/task/index.vue'),
        },
      ],
    },
    {
      path: 'task/picking/detail/:task_number/:order_no',
      props: true,
      name: 'PC.RTSOutbound.Task.PickingTask.Detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.task',
            title: 'Task',
          },
          {
            routeName: 'PC.RTSOutbound.Task.PickingTask.View',
            title: 'Picking Task',
          },
        ],
      },
      component: () => import('@/views/rts-outbound/task/picking/detail.vue'),
    },
    {
      path: 'task/checking/detail/:id',
      name: 'PC.RTSOutbound.Task.Checking.Detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.task',
            title: 'Task',
          },
          {
            routeName: 'PC.RTSOutbound.Task.Checking',
            title: 'Checking Task',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.task.checking.detail',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/rts-outbound/task/checking/detail')
          ),
      },
    },
    {
      path: 'task/new-picking/detail/:pickup_id',
      name: 'PC.RTSOutbound.Task.NewPicking.Detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.task',
            title: 'Task',
          },
          {
            routeName: 'PC.RTSOutbound.Task.NewPicking',
            title: 'New Picking Task',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.task.newPicking.detail',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import('@/react-app/pages/rts-outbound/task/new-picking/detail')
          ),
      },
    },
    {
      path: 'task/merging/detail/:id',
      name: 'PC.RTSOutbound.Task.Merging.Detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.task',
            title: 'Task',
          },
          {
            routeName: 'PC.RTSOutbound.Task.Merging',
            title: 'Merging Task',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.task.merging.detail',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/rts-outbound/task/merging/detail')
          ),
      },
    },
    {
      path: 'picking/:id?',
      name: 'rtsOutbound.picking',
      meta: {
        title: 'Picking',
      },
      component: () => import('../../views/rts-outbound/picking/index.vue'),
    },
    {
      path: 'checking',
      name: 'rtsOutbound.checking',
      meta: {
        title: 'Checking',
        filterSave: true,
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.checking',
      }),
      props: {
        component: () =>
          lazy(() => import('@/react-app/pages/rts-outbound/checking')),
      },
    },
    {
      path: 'shippingStart',
      name: 'rtsOutbound.shippingstart',
      meta: {
        title: 'Start Shipping',
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
        ],
        filterSave: true,
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.shippingstart',
      }),
      props: {
        component: () =>
          lazy(() => import('@/react-app/pages/rts-outbound/shipping')),
      },
    },
    {
      path: 'task/shipping/detail/:id',
      name: 'rtsOutbound.task.shipping.detail',
      meta: {
        title: 'Shipping Task Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'PC.RTSOutbound.Task.Shipping',
            title: 'Shipping Task',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.task.shipping.detail',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/rts-outbound/task/shipping/detail')
          ),
      },
    },
    {
      path: 'shipping',
      name: 'rtsOutbound.shipping',
      meta: {
        title: 'Shipping',
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
        ],
        filterSave: true,
      },
      component: () => import('../../views/rts-outbound/shipping/index.vue'),
    },
    {
      path: 'shipping/create/:taskNumber',
      name: 'rtsOutbound.shipping.create',
      meta: {
        title: 'Shipping Task',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.shipping',
            title: 'Shipping',
          },
        ],
      },
      component: () => import('../../views/rts-outbound/shipping/shipping.vue'),
    },
    {
      path: 'demandpool',
      name: 'rtsOutbound.demandpool',
      meta: {
        title: 'Demand Pool',
        filterSave: true,
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.demandpool',
      }),
      props: {
        component: () =>
          lazy(() => import('@/react-app/pages/rts-outbound/demand-pool')),
      },
    },
    {
      path: 'task/checking/detail/:id',
      name: 'PC.RTSOutbound.Task.Checking.Detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'rtsOutbound',
            title: 'RTS Outbound',
          },
          {
            routeName: 'rtsOutbound.task',
            title: 'Task',
          },
          {
            routeName: 'PC.RTSOutbound.Task.CheckingTask.View',
            title: 'Checking Task',
          },
        ],
      },
      component: reactContainerFactory({
        name: 'rtsOutbound.task.checking.detail',
      }),
      props: {
        component: () =>
          lazy(
            () => import('@/react-app/pages/rts-outbound/task/checking/detail')
          ),
      },
    },
  ],
};

export default rtsOutbound;
